import { render, staticRenderFns } from "./AlipayAnxinCard.vue?vue&type=template&id=4066ed02&scoped=true"
import script from "./AlipayAnxinCard.vue?vue&type=script&lang=js"
export * from "./AlipayAnxinCard.vue?vue&type=script&lang=js"
import style0 from "./AlipayAnxinCard.vue?vue&type=style&index=0&id=4066ed02&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4066ed02",
  null
  
)

export default component.exports